import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {ghabzinoHomePage, ghabzinoPlatformName} from "../../utils/constants";

@Injectable({
  providedIn: 'root'
})
export class ReferrerDetectorService {

  cameFromExternal(): boolean {

    const referrer = document.referrer;
    const appOrigin = window.location.origin;
    let retval:boolean = false;

    if (environment.theme==ghabzinoPlatformName){
      if (!referrer){
        retval = true;
      }else if (!referrer.includes(environment.mainProjectAddress)){
        retval = true
      }else if (!referrer.includes(environment.mainProjectAddress) || !referrer.includes(ghabzinoHomePage)){
        retval = true;
      }
    }
    return retval;
  }

  redirectIfExternal(): void {
    if (this.cameFromExternal()) {
      window.location.href = ghabzinoHomePage;
    }
  }

  getReferrer(): string {
    return document.referrer;
  }
}
